module.exports = __webpack_public_path__ + "static/b_large-5ba54d2fc8a94c1a82f53afb61228c53.jpg";